import { render, staticRenderFns } from "./Index_p.vue?vue&type=template&id=2b77cbcf&scoped=true"
import script from "./Index_p.vue?vue&type=script&lang=js"
export * from "./Index_p.vue?vue&type=script&lang=js"
import style0 from "./Index_p.vue?vue&type=style&index=0&id=2b77cbcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77cbcf",
  null
  
)

export default component.exports